import React, { useEffect, useRef } from 'react';
import axios from 'axios';
import { useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const AuthCallback = () => {
  const { setUsuario } = useContext(AuthContext);
  const navigate = useNavigate();

  const hasRun = useRef(false); // 👈 esto actúa como flag

  useEffect(() => {
    if (hasRun.current) return; // si ya corrió, no vuelve a correr
    hasRun.current = true;

    const getTokensAndUserInfo = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (!code) return console.error('No se encontró el código');

      const clientId = process.env.REACT_APP_GOOGLE_CLIENTID;
      const clientSecret = process.env.REACT_APP_GOOGLE_CLIENTSECRET;
      const redirectUri = process.env.REACT_APP_REDIRECT_GOOGLE_URI;

      try {
        const tokenRes = await axios.post('https://oauth2.googleapis.com/token', {
          code,
          client_id: clientId,
          client_secret: clientSecret,
          redirect_uri: redirectUri,
          grant_type: 'authorization_code',
        });

        const { access_token } = tokenRes.data;

        const userInfoRes = await axios.get('https://www.googleapis.com/oauth2/v2/userinfo', {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });

        const { id, email, name, picture } = userInfoRes.data;

        const data = {
          peticion: 14,
          param: {
            proveedor: 'google',
            id_proveedor: id,
            correo: email,
            nombre_completo: name,
            foto_perfil: picture,
            token_acceso: access_token,
            token_refresh: tokenRes.data.refresh_token || null,
            expira_en: new Date(Date.now() + tokenRes.data.expires_in * 1000),
            scopes: tokenRes.data.scope || null,
            esLogin: 0,
          }
        };

        try {
          if (id && email && name) {
            const response = await fetch('https://estanciamargarita.com.ar/backendBeta/php/servicios/serviciosUsuario.php', {
              method: 'POST',
              headers: new Headers(),
              body: JSON.stringify(data),
            });

            const result = await response.json();

            if (result) {
              setUsuario(result.data);
              localStorage.setItem('usuario', JSON.stringify(result.data));
               toast.success(`Hola bienvenido ${result.data.nombre_completo} 👋`, {
                duration: 4000,
                position: "top-center",
              });
              navigate('/reserva');
            }
          }
        } catch (error) {
          console.error("Error en el intercambio de tokens:", error);
        }

      } catch (err) {
        console.error('Error en el intercambio de tokens:', err);
        navigate('/auth/login');
      }
    };

    getTokensAndUserInfo();
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-lg">Procesando autenticación...</p>
    </div>
  );
};

export default AuthCallback;